module.exports = __webpack_public_path__ + "img/ico_position_header.c3d570ef.svg";